import Card from "@/components/Card";
import React from "react";

import RoundTripsTable from "./RoundTripsTable";
import { BacktestSel } from "@/features/backtest";
import { useRootSelector } from "@/infrastructure/hooks";
import { round } from "lodash";

export default () => {
  const strategyRoundTripSummary = useRootSelector(BacktestSel.strategyRoundTripSummary);
  const strategyRoundTripsProfitLosses = useRootSelector(BacktestSel.strategyRoundTripsPnl).map(e => ({
    ...e,
    allTrades: round(e.allTrades, 2),
    longTrades: round(e.longTrades, 2),
    shortTrades: round(e.shortTrades, 2)
  }));
  const strategyRoundTripsDuration = useRootSelector(BacktestSel.strategyRoundTripsDuration);

  return (
    <div>
      <Card title="Round Trips Summary" bordered={true}>
        <RoundTripsTable data={strategyRoundTripSummary} isDuration={false} />
      </Card>
      <Card title="Round Trips Profit/Loss" bordered={true}>
        <RoundTripsTable data={strategyRoundTripsProfitLosses} isDuration={false} />
      </Card>
      <Card title="Round Trips Duration" bordered={true}>
        <RoundTripsTable data={strategyRoundTripsDuration} isDuration={true} />
      </Card>
    </div>
  );
};
